import { Box, Stack, Typography } from '@mui/material'

import { PulsingDot } from '@/apps/latest/components/atoms/PulsingDot'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { BodyText } from '@/components/atoms/BodyText'
import { MetaText } from '@/components/atoms/MetaText'

import { useKasanStatusesQuery } from '../../hooks/queries/useKasanStatusesQuery'
import { GuidancePrepRow } from '../GuidancePrepRow'

interface Props {
  yakurekiId: string
}

// 加算 panel = 確認要点 list と同じ「marker + 主/従」行 (GuidancePrepRow) で表示する。
//   marker: ○ (適用 / fg.default) / × (非適用 / fg.faint) — 確認要点の「・」と同位置・同サイズ
//   主: 加算名 (BodyText) / 従: 理由 (MetaText)
// 行構造を共通 atom に集約したので section 間で行頭・字色階層が自動で視覚統一される
// (= Notion 引き算: 枠線でなく余白 + 字色階層で構造化)。
export const KasanStatusPanel = ({ yakurekiId }: Props) => {
  const { data, isLoading, error } = useKasanStatusesQuery(yakurekiId)

  if (isLoading) {
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 1, py: 0.5 }}
      >
        <PulsingDot size={8} />
        <Typography variant="body2" color="text.secondary">
          読み込み中…
        </Typography>
      </Box>
    )
  }

  if (error) {
    return (
      <Typography variant="body2" color="error.main" sx={{ pl: 1, py: 0.5 }}>
        加算 status の取得に失敗しました
      </Typography>
    )
  }

  const statuses = data ?? []
  if (statuses.length === 0) {
    return <MetaText sx={{ py: 0.5 }}>該当なし</MetaText>
  }

  return (
    <Stack spacing={1}>
      {statuses.map((s) => {
        const applicable = s.status === 'applicable'
        return (
          <GuidancePrepRow
            key={s.id}
            marker={applicable ? '○' : '×'}
            markerColor={
              applicable ? colorTokens.fg.default : colorTokens.fg.faint
            }
            main={<BodyText>{s.label}</BodyText>}
            sub={s.reason}
          />
        )
      })}
    </Stack>
  )
}
